// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Icon_tooltip__2aWBs","tooltipLg":"Icon_tooltipLg__3eLdy","tooltip1x":"Icon_tooltip1x__1j0zR","esClickeable":"Icon_esClickeable__3ayw4"};